import {
  getEmailByLocale,
  getCurrentByLocale,
  getPhoneCodeByLocale
} from '@/utils/utils'

export const state = () => ({
  pageCookie: '',
  // 分享的域名
  shareHost: 'https://www.poizon.com',
  // 语言
  LANG: 'en',
  // 区域
  AREA: 'HK',
  // 时区 业务有时间相关的请求需在client端重新发起修正时区
  TIME_ZONE: -(new Date().getTimezoneOffset() / 60)
})

export const getters = {
  currency(state) {
    // const map = {
    //   HK: 'HK$',
    //   CN: 'HK$',
    //   US: 'US$',
    //   TW: 'US$',
    //   MO: 'US$',
    //   JP: '￥',
    //   KR: 'KRW'
    // }
    // return map[state.AREA] || map.HK
    return getCurrentByLocale(state.AREA)
  },
  phoneCode(state) {
    // const map = {
    //   HK: 852,
    //   MO: 853,
    //   TW: 886
    // }
    // return map[state.AREA] || map.HK
    return getPhoneCodeByLocale(state.AREA)
  },
  emailAddress(state) {
    // const map = {
    //   HK: 'customer@poizon.com',
    //   MO: 'customer_mo@poizon.com',
    //   TW: 'customer_tw@poizon.com',
    //   JP: 'customer-jp@poizon.com'
    // }
    // return map[state.AREA] || map.HK
    return getEmailByLocale(state.AREA)
  }
}

export const mutations = {
  UP_LANG(state, lang) {
    state.LANG = lang
  },
  UPPageCookie(state, pageCookie) {
    state.pageCookie = pageCookie
  },

  UP_AREA(state, area) {
    state.AREA = area.toUpperCase()
  },
  UP_SHARE_HOST(state, shareHost) {
    state.shareHost = shareHost || 'https://www.poizon.com'
  }
}
